import { ChangeDetectionStrategy, Component, Inject, Input, TemplateRef, ViewChild } from '@angular/core';
import { IModalsService, IMODALS_SERVICE } from '@platform500services/p500-ui-kit';
import { HelpInformationModal } from '../../../modals/help-information/help-information.modal';

@Component({
  selector: 'gtd-help-information',
  templateUrl: './help-information.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HelpInformationComponent {
  @Input() title = $localize`:@@common.help_information:Help Information`;
  @Input() subTitle;
  @Input() linkToDocs = 'https://docs.irev.com/';
  @ViewChild('content', { static: false }) content: TemplateRef<any>;
  @Input() iconName = 'question-circle';

  constructor(@Inject(IMODALS_SERVICE) protected modalsService: IModalsService) {}

  openModal() {
    this.modalsService.open(HelpInformationModal, {
      title: this.title,
      subTitle: this.subTitle,
      linkToDocs: this.linkToDocs,
      content: this.content,
    });
  }
}
